module.exports = __webpack_public_path__ + "static/lake-22-02dc7c71ecb7ee41bfaa345303af6736.jpg";